
import React, { useEffect, useState } from 'react'
import {BrowserRouter, Navigate, Route, Routes,useNavigate} from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import Dashboard from '../Containers/Dashboardpage/Dashboard';
import MetricsReport from '../Containers/FormsPage/MetricsReport';
import Applications from '../Containers/Applicationspage/Applications';
import Reports from '../Containers/Reports/Reports';
import Form from '../Containers/Form/Form';
import Login from '../Login/Login';
import Welcome from '../Login/Welcome/Welcome';
import Onboarding from '../Login/Onboarding/Onboarding';
import claimButton from '../Claim/Claim';
import Viewsubmission from '../Containers/Viewsubmission/Viewsubmission';
import { selectIsActive } from '@formio/react';
import UserManagement from '../Components/UserManagement/UserManagement';
import Settings from '../Components/Settings/Settings';
import UserDetails from '../Components/Settings/UserDetails/UserDetail';

function Routing(props) {

 
  

  const [lastUrl, setLastUrl] = useState('');

   

  const Navigate=useNavigate();


 


  useEffect(() => {
    localStorage.setItem('lastUrl', window.location.pathname);
  }, [lastUrl]);

  useEffect(() => {
    const storedUrl = localStorage.getItem('lastUrl');
    if (storedUrl) {
      Navigate(storedUrl)
    } else {
      setLastUrl(window.location.pathname);
    }
  }, []);



  // useEffect(()=>
  // {
   
  //     Navigate("/dashboard")
     
   
    
    
      
  // },[])





  // useEffect(()=>
  // {
  //   Navigate("/dashboard");
      
 
    
      
  // },[])





  return (
    <Routes>
    

   



    

        <Route exact path='/' element={<Sidebar/>}>
        <Route exact path='/' element={<Navigate to="/dashboard"/>}/>
        {/* <Route exact path='/settings' element={<Setting/>}/> */}
        <Route exact path='/dashboard' element={<Dashboard state={props.state}/>}/>
        <Route exact path='/forms' element={<MetricsReport state={props.state} application={false}/>}/>
        {/* <Route exact path='/applications' element={<Applications state={props.state}/>}/> */}
        <Route exact path='/applications'  element={<MetricsReport state={props.state} application={true}/>}/>
        

        <Route exact path='/reports' element={<Reports state={props.state}/>}/>
        <Route exact path='/forms/:_id' element={<Form state={props.state} /> }/>
        <Route exact path='/applications/:_id' element={<Form state={props.state} /> }/>
        <Route exact path='/usermanagement' element={<UserManagement state={props.state} />}/>
        <Route exact path='/settings' element={<Settings state={props.state}/>}/>
        <Route exact path='/userdetails/:_id' element={<UserDetails state={props.state} />}/>
        </Route>
        <Route exact path='/login' element={<Login/> }/>
        <Route exact path='/welcome' element={<Welcome/> }/>
        <Route exact path='/welcome/onboarding' element={<Onboarding/> }/>
        <Route exact path="/Viewsubmission/:_first/submission/:_second" element={<Viewsubmission/>  } />
   
    
    </Routes>
  );
}

export default Routing;
